exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-form-item .error-message[data-v-36ceb5c9] {\n  color: red;\n}\n\n", ""]);

// exports
